export default __webpack_public_path__ + "static/media/google-play-badge.ca6dbf31.svg";